module.exports = __webpack_public_path__ + "img/11a.454d564d.png";